import { Flex } from "discover.medical.react-component-library";
import styled from "styled-components";

export const AlertContainer = styled(Flex)`
  border: none;
  padding: ${({ theme }) => theme.space.sm};
`;
